<template>
    <Sidebar>
        <template #header>
            <h1 class="logo-container logo">
                <a href="https://stoen.pl/">
                    <img class="" src="../../assets/logoStoenRed.svg" alt="Przejście na stronę główną stoen.pl" />
                </a>
            </h1>
        </template>

        <div class="login-form" v-show="mode === 'login'">
            <VeeForm @submit="submitLogin">
                <h2>{{$t('message.login.action.login')}}</h2>
                <div class="login-inputs">
                    <EonInputText rules="required|email" name="login" v-model="loginForm.login"
                                  :label="$t('message.login.eonLogin')" />
                    <EonPassword rules="required" name="password" v-model="loginForm.password"
                                 :label="$t('message.login.password')" />
                </div>
                <div class="login-actions">
                    <EonButton :label="$t('message.login.action.login')" extension="-20" type="submit" />
                    <EonHref href="#" :label="$t('message.login.action.eonRemindPassword')" color="red"
                             @click.prevent="goRemind" />
                </div>
            </VeeForm>
        </div>

        <h2 v-show="mode === 'login'">{{ 'Nie masz konta?' }}</h2>
        <EonOutlinedButton :label="$t('message.login.action.register')" type="button" @click="goRegister"
                           extension="-20" v-show="mode === 'login'" title="Zmiana widoku strony" />

        <div class="register-form" v-show="mode === 'register'">
            <VeeForm @submit="submitRegister" v-slot="{ errors }">
                <h2>{{ $t('message.register.register') }}</h2>
                <div class="register-inputs">
                    <EonInputText rules="required" name="fullName" v-model="registerForm.fullName"
                                  :label="$t('message.register.fullName')" />
                    <EonInputText rules="required|email" name="email" v-model="registerForm.email"
                                  :label="$t('message.register.email')" />
                    <EonPassword rules="required|validPassword" name="password" v-model="registerForm.password"
                                 :label="$t('message.register.password')" />
                </div>
                <div class="register-actions">
                    <EonButton :disabled="isDisabled(errors)" :label="$t('message.register.action.register')"
                               type="submit" />
                </div>
            </VeeForm>
        </div>

        <h2 v-show="mode === 'register'">{{ 'Masz już konto?' }}</h2>
        <EonOutlinedButton :label="$t('message.login.action.login')" type="button" @click="goLogin" extension="-20"
                           v-show="mode === 'register'" />

        <div class="eon-remind-field" v-show="mode === 'remind'">
            <div>
                <h2>{{ $t('message.login.action.eonRemindPassword') }}</h2>
            </div>

            <VeeForm @submit.prevent="submitRemind" v-slot="{ errors }">
                <p>{{ $t('message.login.action.remindPasswordDetails') }}</p>
                <EonInputText class="eon-remind-input" name="email" v-model="passwordRemindForm.email"
                              :label="$t('message.login.eonLogin')" rules="required|email" />
                <div style="display: flex; flex-direction: row;">
                    <EonButton class="eon-remind-input" :label="$t('message.login.action.send')"
                               :disabled="isDisabled(errors)" type="submit" />
                    <EonOutlinedButton class="eon-remind-input" label="Powrót" @click="goLogin" />
                </div>
            </VeeForm>
        </div>
    </Sidebar>
</template>

<script>
    import {useRouter} from "vue-router";
    import {
        remindPassword,
    } from "@/swagger/vue-api-client";
    import {SystemRole} from "@/utils/SystemRole";
    import Sidebar from "primevue/sidebar";
    import {Form as VeeForm} from "vee-validate";
    import EonInputText from "./EonInputText";
    import EonPassword from "./EonPassword";
    import EonButton from "./EonButton";
    import EonHref from "./EonHref";
    import EonOutlinedButton from "./EonOutlinedButton";

    export default {
        name: "EonSidebarMobile",
        components: {
            EonOutlinedButton,
            EonHref,
            EonButton,
            EonPassword,
            EonInputText,
            VeeForm,
            Sidebar,
        },
        data() {
            return {
                mode: "login",
                sidebarState: {
                    login: false,
                    info: false,
                    visible: false,
                },
                loginForm: {
                    login: "",
                    password: "",
                },
                registerForm: {
                    fullName: "",
                    email: "",
                    password: "",
                },
                sending: false,
                passwordRemindForm: {
                    email: "",
                },
                cookiesPolicyUrl: process.env.VUE_APP_COOKIES_URL,
                isUserLoggedIn: SystemRole.isPublic(),
                router: useRouter(),
            };
        },
        methods: {
            goRegister() {
                this.mode = "register";
            },
            goLogin() {
                this.mode = "login";
            },
            goRemind() {
                this.mode = "remind";
            },
            submitLogin() {
                this.$emit("login", this.loginForm);
            },
            submitRegister() {
                this.$emit("register", this.registerForm);
            },
            submitRemind() {
                this.$emit("remind", this.passwordRemindForm);
            },
            isDisabled(errors) {
                return !(errors && Object.keys(errors).length === 0
                    && Object.getPrototypeOf(errors) === Object.prototype);
            },
            remind() {
                this.sending = true;
                remindPassword({body: this.passwordRemindForm});
            },
            isPublic() {
                return window.location.href.includes("public");
            },
        },
        watch: {
            "$route.path": function (newPath) {
                if (newPath === "/public/remind") {
                    this.mode = "remind";
                } else if (newPath === "/public/register") {
                    this.mode = "register";
                } else {
                    this.mode = "login";
                }
            },
        },
    };
</script>

<style scoped>
.login-form {
    margin-bottom: 5em;
    .login-inputs {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        row-gap: 1em;
        margin-bottom: 2em;
    }
    .login-actions {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
    }
}
.register-form {
    margin-bottom: 2em;
    .register-inputs {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        row-gap: 1em;
        margin-bottom: 2em;
    }
    .register-actions {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
    }
}
.policy {
    font-size: 0.75rem;
    margin-bottom: 2em;
}
.logo {
    height: 4em;
    padding-right: 1em;
    padding-left: 1em;
    padding-top: 0.5em;
}
.logo-container {
    display: flex;
    align-items: center;
    padding: 0;
    margin-left: 1em;
}
</style>
